import React from 'react'
import { styled, Table, Label, getLocalizedProperty } from '@tools/wr-catalog-base'

const StyledTable = styled(Table)`
  /* Align with the Schedule table (which is an image) */
  margin-left: 2px;
  width: 950px;

  th {
    color: #fff;
    background-color: #5bb73b;
  }

  th,
  td {
    border-color: #000;
    padding: 4px;

    &:nth-child(1) {
      width: 157px;
    }

    &:nth-child(2) {
      width: 90px;
    }
  }
`

const COLUMNS = [
  {
    id: 'role',
    label: 'Role',
  },
  {
    id: 'hours',
    label: 'Hours',
  },
  {
    id: 'skillset',
    label: 'Skillset',
  },
]
export default function CustomTable({ row }) {
  const sourceList = row.lists[0]
  const getLRow = (id) => sourceList.listRows.find((lr) => lr.id === id)
  const dataRows = Array.isArray(row.control) ? row.control : []
  const data = dataRows.map((dr, i) => {
    const dropdownValues = dr.dropdowns[sourceList.id]
    const dropdownLabels = dropdownValues.map((val) => getLRow(val).key)
    return {
      id: String(i),
      role: dropdownLabels.join(', '),
      hours: dr.shortAnswer,
      skillset: dr.notes || '',
    }
  })

  return (
    <>
      <Label>{getLocalizedProperty(row, 'label')}</Label>
      <StyledTable columns={COLUMNS} data={data} keyField="id" />
    </>
  )
}
